module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"9.9px\" height=\"6.4px\" viewBox=\"-474 277.6 9.9 6.4\" enable-background=\"new -474 277.6 9.9 6.4\" xml:space=\"preserve\"><polygon fill=\"#007FAD\" points=\"-465.5,277.6 -469.1,281.1 -472.6,277.6 -474,279 -469.1,284 -464.1,279 \"></polygon></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/arrow_dropdown_blue.svg
 ** module id = 1035
 ** module chunks = 0
 **/